import { useEffect, useState } from 'react';
const INITIAL_SLIDE_INDEX = 0;
const getInitialSlidesDisplayState = (slidesAmount, activeSlideIndex, isNextSlideVideo) => new Array(slidesAmount)
    .fill(false)
    .map((_, index) => index === activeSlideIndex || (index === activeSlideIndex + 1 && !isNextSlideVideo));
export const useSlidesDisplayState = (activeSlideIndex, slidesAmount, isNextSlideVideo) => {
    const [isRendered, setIsRendered] = useState(false);
    const [slidesDisplayState, setSlidesDisplayState] = useState(getInitialSlidesDisplayState(slidesAmount, activeSlideIndex, isNextSlideVideo));
    useEffect(() => {
        if (isRendered) {
            const isAllSlidesDisplayed = !slidesDisplayState.some(item => item);
            if (!isAllSlidesDisplayed) {
                const newSlidesLoadingState = slidesDisplayState.map((state, index) => index === activeSlideIndex - 1 || index === activeSlideIndex || index === activeSlideIndex + 1 ? true : state);
                setSlidesDisplayState(newSlidesLoadingState);
            }
        }
        else {
            setIsRendered(true);
        }
    }, [activeSlideIndex]);
    useEffect(() => {
        if (isRendered) {
            setSlidesDisplayState(getInitialSlidesDisplayState(slidesAmount, INITIAL_SLIDE_INDEX, isNextSlideVideo));
        }
    }, [slidesAmount]);
    return slidesDisplayState;
};
